import { useEffect, useRef } from 'react'
import { useFrame } from '@react-three/fiber'
import { useScene } from '../scene/store'

/** Seconden na het eerste beeld die niet meetellen: shaders, texturen, opstart. */
const OPWARMEN = 2.5
/** Seconden waarover gemeten wordt. */
const METEN = 4
/**
 * Onder deze framerate gaat de kiosk naar het lichte profiel. Niet 60: een
 * paneel op 50 ziet er vloeiend uit, en het volle profiel is het waard. Wel
 * ruim boven 30, want daaronder haperen de cameravluchten zichtbaar.
 */
const DREMPEL = 45

/**
 * De prestatiemeting binnen het canvas (PLAN.md §0.10): meet bij het
 * opstarten één keer de framerate. Haalt de pc het volle profiel niet, dan
 * schakelt hij zelf naar licht en onthoudt dat voor deze machine — de
 * volgende start begint dan meteen licht, zonder eerst te haperen. (De
 * pixeldichtheid van het profiel zet App.tsx als prop op het canvas.)
 *
 * Wordt niet gemeten als iemand in het beheerderspaneel een profiel koos, als
 * het profiel al licht is, of als het tabblad niet zichtbaar is (dan knijpt
 * de browser requestAnimationFrame af en zou elke meting "te traag" zeggen).
 */
export function Prestatie() {
  const profiel = useScene((s) => s.profiel)
  const bron = useScene((s) => s.profielBron)
  const meetRonde = useScene((s) => s.meetRonde)
  const zetProfiel = useScene((s) => s.zetProfiel)
  const meldFps = useScene((s) => s.meldFps)

  const meting = useRef({ tijd: 0, beelden: 0, klaar: false })
  useEffect(() => {
    meting.current = { tijd: 0, beelden: 0, klaar: profiel !== 'vol' || bron === 'handmatig' }
    // Alleen bij een nieuwe ronde of keuze; het profiel zelf wisselt hierdoor.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetRonde, bron])

  useFrame((_, delta) => {
    const m = meting.current
    if (m.klaar) return
    if (document.visibilityState !== 'visible') { m.tijd = 0; m.beelden = 0; return }
    m.tijd += delta
    if (m.tijd < OPWARMEN) return
    m.beelden++
    const gemeten = m.tijd - OPWARMEN
    if (gemeten < METEN) return

    m.klaar = true
    const fps = Math.round(m.beelden / gemeten)
    meldFps(fps)
    document.documentElement.dataset.fps = String(fps)
    if (fps < DREMPEL) {
      console.info(`[prestatie] ${fps} fps in het volle profiel — naar licht`)
      zetProfiel('licht', 'auto')
    } else {
      console.info(`[prestatie] ${fps} fps in het volle profiel — blijft vol`)
    }
  })

  return null
}
